




































import Vue from 'vue';
import Searchbox from '@/components/searchbox/Searchbox.vue';
import { IHeaderMobileComponent, IMenus } from '@/common/interfaces/header.interface';
import HeaderMobileCommon from './HeaderMobileCommon.vue';
import MobileAccount from './MobileAccount.vue';
import MobileLanguage from './MobileLanguage.vue';
import MobileNavigation from './MobileNavigation.vue';

export default Vue.extend({
  name: `HeaderMobile`,
  components: {
    HeaderMobileCommon,
    MobileAccount,
    MobileLanguage,
    MobileNavigation,
    Searchbox,
  },
  data(): IHeaderMobileComponent {
    return {
      headerMenuOpen: false,
      openedAccount: false,
      openedSetup: false,
      selectedTopic: false,
    };
  },
  computed: {
    accountVisible(): boolean {
      return this.headerMenuOpen && !this.openedSetup && !this.selectedTopic;
    },
    navigationVisible(): boolean {
      return this.headerMenuOpen && !this.openedAccount && !this.openedSetup;
    },
    setupVisible(): boolean {
      return this.headerMenuOpen && !this.openedAccount && !this.selectedTopic;
    },
  },
  props: {
    cartItemsCount: {
      required: true,
      type: Number,
    },
    chosenLanguage: {
      required: true,
      type: String,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    isPartnerShop: {
      required: true,
      type: Boolean,
    },
    languages: {
      required: true,
      type: Array as () => string[],
    },
    loading: {
      required: true,
      type: Boolean,
    },
    loggedIn: {
      required: true,
      type: Boolean,
    },
    menus: {
      required: true,
      type: Object as () => IMenus,
    },
  },
  methods: {
    stateAccount(state: boolean): void {
      this.openedAccount = state;
    },
    stateNavigation(state: boolean) : void {
      this.selectedTopic = state;
    },
    stateSetup(state: boolean) : void {
      this.openedSetup = state;
    },
    switchLanguage(code: string): void {
      this.$emit(`change:language`, code);
    },
  },
});
